var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { injectIntl, FormattedNumber } from 'react-intl';
import { truncate } from "../../../utils/stringUtils";
import { ApplicationContext } from '../../../ApplicationContext';
import DateTime from '../../components/ui/DateTime/DateTime';
import Signals from '../../../signals/Signals';
import ServiceEntryViewOverlay from './ViewServiceEntryOverlay';
import classNames from "classnames";
/**
 *
 */
var ClosedServiceEntriesRow = /** @class */ (function (_super) {
    __extends(ClosedServiceEntriesRow, _super);
    /**
     *
     */
    function ClosedServiceEntriesRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.onViewServiceEntry = _this.onViewServiceEntry.bind(_this);
        return _this;
    }
    /**
     *
     * @returns {*}
     */
    ClosedServiceEntriesRow.prototype.render = function () {
        var _a = this.props, serviceEntryModel = _a.serviceEntryModel, compact = _a.compact;
        var assetCollection = this.context.assetCollection;
        var assetModel = assetCollection.list.find(function (asset) { return asset.getAssetSerial() === serviceEntryModel.assetId; });
        var classes = classNames({
            'service-entries-row': true,
            "bg-white": true,
            'mb-4': !compact,
            'mb-2': compact,
            "pl-3": true,
            "pr-3": true,
            'pt-4': !compact,
            'pb-4': !compact,
            'pt-2': compact,
            'pb-2': compact,
        });
        return (React.createElement("div", { className: classes, onClick: this.onViewServiceEntry, style: { display: "contents" } },
            React.createElement("div", { className: "text-nowrap" },
                React.createElement(DateTime, { relativeTimeClasses: "text-muted", date: serviceEntryModel.closeDateTimeUtc, hideTime: true, compact: compact })),
            React.createElement("div", { className: "text-wrap" }, serviceEntryModel.name),
            React.createElement("div", { className: "text-nowrap" },
                React.createElement("div", { className: "btn-link cursor-pointer", onClick: function (event) {
                        event.stopPropagation();
                        Signals.HideOverlay.dispatch();
                        Signals.ShowAssetDetail.dispatch(assetModel);
                    } }, assetModel ? assetModel.properties.displayedId : serviceEntryModel.assetEquipmentId)),
            React.createElement("div", { className: "text-no-wrap", title: serviceEntryModel.description }, truncate(serviceEntryModel.description)),
            React.createElement("div", { className: "text-no-wrap", title: serviceEntryModel.resolution }, truncate(serviceEntryModel.resolution)),
            React.createElement("div", { className: "text-nowrap" }, serviceEntryModel.assignedTo),
            React.createElement("div", { className: "text-nowrap" }, serviceEntryModel.operatorName),
            React.createElement("div", { className: "text-nowrap text-right" }, serviceEntryModel.assetValueOnCreation > 0 ?
                React.createElement(FormattedNumber, { value: serviceEntryModel.assetValueOnCreation, style: "unit", unit: "hour", minimumFractionDigits: 1, maximumFractionDigits: 1 }) : '-'),
            React.createElement("div", { className: "text-nowrap text-right" }, serviceEntryModel.assetValueOnClose > 0 ?
                React.createElement(FormattedNumber, { value: serviceEntryModel.assetValueOnClose, style: "unit", unit: "hour", minimumFractionDigits: 1, maximumFractionDigits: 1 }) : '-')));
    };
    /**
     *
     * @param event
     */
    ClosedServiceEntriesRow.prototype.onViewServiceEntry = function (event) {
        event.stopPropagation();
        var serviceEntryModel = this.props.serviceEntryModel;
        Signals.ShowOverlay.dispatch(React.createElement(ServiceEntryViewOverlay, { serviceEntryModel: serviceEntryModel }));
    };
    ClosedServiceEntriesRow = __decorate([
        observer
    ], ClosedServiceEntriesRow);
    return ClosedServiceEntriesRow;
}(React.Component));
ClosedServiceEntriesRow.contextType = ApplicationContext;
export default injectIntl(ClosedServiceEntriesRow);
